/* hero-loop autoplay helper — persist until currentTime advances */
(function () {
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function headerOffset() {
    const sticky = document.querySelector('sticky-header');
    if (sticky) return sticky.offsetHeight + 16;
    const header = document.querySelector('.section-header') || document.querySelector('header');
    return (header ? header.offsetHeight : 0) + 16;
  }

  function targetScrollTop(target) {
    return target.getBoundingClientRect().top + window.scrollY - headerOffset();
  }

  function smoothScrollTo(target) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      window.scrollTo(0, targetScrollTop(target));
      return;
    }

    const start = window.scrollY;
    const initialDistance = targetScrollTop(target) - start;
    if (Math.abs(initialDistance) < 2) return;

    const duration = Math.min(1100, Math.max(480, Math.abs(initialDistance) * 0.55));
    let startTime = null;

    function frame(now) {
      if (startTime == null) startTime = now;
      const progress = Math.min(1, (now - startTime) / duration);
      const destination = targetScrollTop(target);
      window.scrollTo(0, start + (destination - start) * easeInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        window.scrollTo(0, targetScrollTop(target));
        window.setTimeout(function () {
          window.scrollTo(0, targetScrollTop(target));
        }, 380);
      }
    }

    requestAnimationFrame(frame);
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-vibe-smooth-scroll]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    const target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', href);
    smoothScrollTo(target);
  });

  function init(root) {
    if (!root || root.dataset.videoReady === 'true') return;
    const video = root.querySelector('[data-vibe-hero-video]');
    if (!video) return;

    root.dataset.videoReady = 'true';
    const media = root.querySelector('.vibe-home__media');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reduceMotion.matches) {
      /* Static poster only — respect OS “reduce motion” */
      video.pause();
      video.removeAttribute('autoplay');
      video.removeAttribute('src');
      try {
        video.load();
      } catch (err) {}
      return;
    }

    var blobTried = false;
    var originalSrc = video.getAttribute('src') || video.currentSrc || '';

    function prep() {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.loop = true;
      video.controls = false;
      video.removeAttribute('controls');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
    }

    function alive() {
      return !video.paused && !video.ended && video.currentTime > 0.05;
    }

    function markPlaying() {
      if (alive() && media) media.classList.add('is-playing');
    }

    function tryPlay() {
      if (alive()) {
        markPlaying();
        return Promise.resolve(true);
      }
      prep();
      var p = video.play();
      if (p && typeof p.then === 'function') {
        return p
          .then(function () {
            markPlaying();
            return true;
          })
          .catch(function () {
            return false;
          });
      }
      markPlaying();
      return Promise.resolve(alive());
    }

    /** Fallback: same-origin blob URL if CDN src play keeps failing */
    function tryBlob() {
      if (blobTried || !originalSrc || !window.fetch || !window.URL) return;
      blobTried = true;
      var abs = originalSrc;
      try {
        abs = new URL(originalSrc, window.location.href).href;
      } catch (err) {}
      fetch(abs, { mode: 'cors', credentials: 'omit' })
        .then(function (res) {
          return res.blob();
        })
        .then(function (blob) {
          var obj = URL.createObjectURL(blob);
          video.src = obj;
          prep();
          return tryPlay();
        })
        .catch(function () {});
    }

    prep();
    video.addEventListener('playing', markPlaying);
    video.addEventListener('timeupdate', markPlaying);
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);
    video.addEventListener('canplaythrough', tryPlay);
    video.addEventListener('progress', tryPlay);
    tryPlay();

    var started = Date.now();
    var timer = window.setInterval(function () {
      if (alive()) {
        markPlaying();
        window.clearInterval(timer);
        return;
      }
      tryPlay().then(function (ok) {
        if (!ok && Date.now() - started > 2500) tryBlob();
      });
    }, 400);

    function resume() {
      tryPlay();
    }
    document.addEventListener('pointerdown', resume, true);
    document.addEventListener('touchstart', resume, { capture: true, passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') resume();
    });
    window.addEventListener('pageshow', resume);
  }

  function initAll() {
    document.querySelectorAll('[data-vibe-home]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector?.('[data-vibe-home]') || event.target;
    if (root && root.hasAttribute && root.hasAttribute('data-vibe-home')) {
      root.dataset.videoReady = '';
      init(root);
    } else {
      initAll();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
